import PerfilPaciente from "./PerfilPaciente";
export default PerfilPaciente;